import { SITE_URL, BRAND, CONTACT, SOCIALS, IMAGES, SERVICES } from "@/data/site";

const abs = (u) => (u && u.startsWith("http") ? u : `${SITE_URL}${u || ""}`);

const sameAs = [SOCIALS.instagram, SOCIALS.tiktok, SOCIALS.facebook].filter(Boolean);

// NOTE: no aggregateRating and no openingHours - not fabricating ratings/hours.
export function beautySalonSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "BeautySalon",
    "@id": `${SITE_URL}/#business`,
    name: BRAND.name,
    image: abs(IMAGES.hero),
    url: SITE_URL,
    telephone: "+19548664799",
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      addressLocality: BRAND.city,
      addressRegion: BRAND.region,
      postalCode: BRAND.postalCode,
      addressCountry: BRAND.country,
    },
    areaServed: { "@type": "City", name: "Vero Beach" },
    description:
      "Luxury lash extensions, brow services, beauty treatments and professional lash training in Vero Beach, Florida.",
    makesOffer: SERVICES.map((s) => ({
      "@type": "Offer",
      itemOffered: { "@type": "Service", name: s.title },
    })),
    ...(sameAs.length ? { sameAs } : {}),
  };
}

export function breadcrumb(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: abs(it.path),
    })),
  };
}

export function serviceSchema(service) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name: service.title,
    serviceType: service.title,
    description: service.short,
    image: abs(service.work),
    areaServed: { "@type": "City", name: "Vero Beach" },
    provider: { "@type": "BeautySalon", name: BRAND.name, "@id": `${SITE_URL}/#business` },
    ...(service.options && service.options.length
      ? {
          hasOfferCatalog: {
            "@type": "OfferCatalog",
            name: `${service.title} Options`,
            itemListElement: service.options.map((o) => ({
              "@type": "Offer",
              itemOffered: { "@type": "Service", name: `${o} ${service.title}` },
            })),
          },
        }
      : {}),
  };
}

export function faqSchema(faqs) {
  if (!faqs || !faqs.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export function educationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "EducationalOccupationalProgram",
    name: "Golden Touch Lash & Brow Training",
    description:
      "Professional lash and brow training for aspiring beauty artists in Vero Beach, Florida.",
    provider: { "@type": "BeautySalon", name: BRAND.name, "@id": `${SITE_URL}/#business` },
    occupationalCategory: "Lash and Brow Artistry",
  };
}
